
import React from 'react';
import { Link } from 'react-router-dom'; 
import { FaLifeRing, FaBookOpen, FaQuestionCircle } from 'react-icons/fa'; 
import './SopRelatedLinksSection.css'; 

const SopRelatedLinksSection = () => {
  return (
    <section className="_sRLSect_z1A_"> 
      <div className="_sRLCont_a2B_"> 
        <h3 className="_rLTitle_b3C_" style={{marginBottom:"1.6rem",paddingBottom:"1.6rem"}}> 
          Related Guides
        </h3>
        <div className="_rLWrapper_c4C_" style={{margintop:"0"}}> 
          <Link to="/support" className="_rLink_d5C_ support-link-btn _dBtn_v5C_ word-button"> 
            <FaLifeRing className="_lIcon_e6C_" /> Support Center
          </Link>
          <Link to="/support-handbook" className="_rLink_d5C_ handbook-link-btn _dBtn_v5C_ word-button"> 
            <FaBookOpen className="_lIcon_e6C_" /> Support Handbook
          </Link>
          <Link to="/faq" className="_rLink_d5C_ faq-link-btn _dBtn_v5C_ word-button"> 
            <FaQuestionCircle className="_lIcon_e6C_" /> FAQs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SopRelatedLinksSection;